// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { externalTestPartnerId } from './ExternalTestPartner';
import { testAttributeCodeCode } from './TestAttributeCode';
import { operatorId } from './Operator';
import { z } from 'zod';
export const testAttributeCodeAliasId = (z.number());
export const testAttributeCodeAlias = z.object({
    id: testAttributeCodeAliasId,
    external_test_partner_id: externalTestPartnerId,
    lab_parameter_code: z.string().nullable(),
    lab_parameter_name: z.string(),
    lab_unit: z.string().nullable(),
    attribute_code: testAttributeCodeCode.nullable(),
    unit_factor: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    row_key: z.string().nullable(),
    ignored: z.boolean(),
});
export const testAttributeCodeAliasInitializer = z.object({
    id: testAttributeCodeAliasId.optional(),
    external_test_partner_id: externalTestPartnerId,
    lab_parameter_code: z.string().optional().nullable(),
    lab_parameter_name: z.string(),
    lab_unit: z.string().optional().nullable(),
    attribute_code: testAttributeCodeCode.optional().nullable(),
    unit_factor: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    row_key: z.string().optional().nullable(),
    ignored: z.boolean().optional(),
});
export const testAttributeCodeAliasMutator = z.object({
    id: testAttributeCodeAliasId.optional(),
    external_test_partner_id: externalTestPartnerId.optional(),
    lab_parameter_code: z.string().optional().nullable(),
    lab_parameter_name: z.string().optional(),
    lab_unit: z.string().optional().nullable(),
    attribute_code: testAttributeCodeCode.optional().nullable(),
    unit_factor: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    row_key: z.string().optional().nullable(),
    ignored: z.boolean().optional(),
});
//# sourceMappingURL=TestAttributeCodeAlias.js.map